import { Action } from '@ngrx/store';

import { PaginatedResults } from '../../record/entities/pagination/paginated-results.entity';
import { ApiFragment } from '../../record/entities/api-fragment.entity';

export enum OverviewOptionsActionTypes {
    InitializePageCache = '[OverviewPageCache] Initialize Page Cache',
    AddPageToCache = '[OverviewPageCache] Cache Page'
}

export class InitializePageCache implements Action {
    type: OverviewOptionsActionTypes.InitializePageCache = OverviewOptionsActionTypes.InitializePageCache;
    constructor(public overview: string, public index: number, public page: PaginatedResults<ApiFragment>) {}
}

export class AddPageToCache implements Action {
    type: OverviewOptionsActionTypes.AddPageToCache = OverviewOptionsActionTypes.AddPageToCache;
    constructor(public overview: string, public index: number, public page: PaginatedResults<ApiFragment>) {}
}

export type OverviewPageCacheAction = InitializePageCache | AddPageToCache;
